/**
 * Fenice Italy Business API
 * # Fenice Italy Business API  ## General Http Status: HTTP STATUS CODE | DESCRIPTION --- | --- 400 | Business error or general error 401 | Expired token 403 | Access token does not have the required scope 404 | Not found 500 | Internal error  ## Specific Error Codes: Verti has specific errors based on validations, in error field *code*  CODE | DESCRIPTION --- | --- KOIT001 | Plate not valid from SIC/SITA. KOIT002 | Vehicle plate number is not valid. KOIT003 | Login failed. Password is not correct.  ## Annotations:   - In those services that return a list of items, in the case of not found any of them, it will return an empty list.   - For date format, standard ISO 8601. (YYYY-MM-DDThh:mm:ss.sTZD)
 *
 * OpenAPI spec version: 1.2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Address } from './address';
import { ContactMethod } from './contactMethod';
import { NaturalPerson } from './naturalPerson';
import { PartnershipCard } from './partnershipCard';
import { SecurityInfo } from './securityInfo';

export interface User {
  /**
   * User identificator
   */
  userId?: string;
  /**
   * Application identificator
   */
  applicationName?: string;
  naturalPerson?: NaturalPerson;
  userAddr?: Address;
  contactMethods?: Array<ContactMethod>;
  securityInfo?: SecurityInfo;
  /**
   * Partnership cards related to the user
   */
  partnershipCard?: Array<PartnershipCard>;
  status?: User.StatusEnum;
  type?: User.TypeEnum;
  customerRetentionFlag?: boolean;
}
export namespace User {
  export type StatusEnum =
    | 'ENABLED'
    | 'SECURE_LINK'
    | 'MERGED'
    | 'TO_BE_COMPLETE'
    | 'TO_BE_CONFIRM'
    | 'NOT_VALID'
    | 'EXISTS_MYDL'
    | 'TO_BE_CONFIRMED'
    | 'TO_BE_CONFIRMED_WITH_MYLS'
    | 'TO_BE_COMPLETED'
    | 'TO_BE_COMPLETED_WITH_MYLS'
    | 'AVAILABLE'
    | 'AVAILABLE_WITH_MYLS';
  export const StatusEnum = {
    ENABLED: 'ENABLED' as StatusEnum,
    SECURELINK: 'SECURE_LINK' as StatusEnum,
    MERGED: 'MERGED' as StatusEnum,
    TOBECOMPLETE: 'TO_BE_COMPLETE' as StatusEnum,
    TOBECONFIRM: 'TO_BE_CONFIRM' as StatusEnum,
    NOTVALID: 'NOT_VALID' as StatusEnum,
    EXISTSMYDL: 'EXISTS_MYDL' as StatusEnum,
    TOBECONFIRMED: 'TO_BE_CONFIRMED' as StatusEnum,
    TOBECONFIRMEDWITHMYLS: 'TO_BE_CONFIRMED_WITH_MYLS' as StatusEnum,
    TOBECOMPLETED: 'TO_BE_COMPLETED' as StatusEnum,
    TOBECOMPLETEDWITHMYLS: 'TO_BE_COMPLETED_WITH_MYLS' as StatusEnum,
    AVAILABLE: 'AVAILABLE' as StatusEnum,
    AVAILABLEWITHMYLS: 'AVAILABLE_WITH_MYLS' as StatusEnum,
  };
  export type TypeEnum = 'INTRODUCER' | 'MYDL' | 'SECURELINK' | 'SECUREPIN';
  export const TypeEnum = {
    INTRODUCER: 'INTRODUCER' as TypeEnum,
    MYDL: 'MYDL' as TypeEnum,
    SECURELINK: 'SECURELINK' as TypeEnum,
    SECUREPIN: 'SECUREPIN' as TypeEnum,
  };
}
